import { createMeta } from "../../../components/TapHeader";

const title = "Calendar";
export const CalendarMeta = createMeta(title);
